<template>
  <page-outline :title="$t('attachments.import_file')">
    <template slot="pageContent">
      <b-row class="justify-content-start">
        <b-col xl="2" offset="2" class="pt-2 my-1 mr-5 font-weight-bold">
          <label class="text-dark">{{ $t('common.chse_file_up') }}</label> *
        </b-col>
        <b-col xl="4" class="mr-5 form-group">
          <input class="form-control" ref="fileInput" type="file" name="file2" id="file2"  @change="onFileChange" accept=".xml"></input>
        </b-col>
        <b-col xl="1" class="ml-5 form-group text-center">
          <b-button variant="primary" size="lg" style="width: 135px"
            @click="importAttachment">
            <span>{{ $t('bank_accounts.imprt') }}</span>
          </b-button>
        </b-col>
        <b-col xl="12" offset="2">
          <i>{{ $t('common.asterisk_obligation_label') }}</i>
        </b-col>
      </b-row>
      <br/>
      <br/>
    </template>
  </page-outline>
</template>
<script>

import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'ImportFiles',
  components: {
    'page-outline': PageOutline
  },
  data () {
    return {
      attachment: '',
      attachmentName: '',
      isSmartphone: false,
      mimeType: '',
      report: []
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.mimeType = ''
    this.attachment = ''
    this.attachmentName = ''
  },
  methods: {
    createImage (file) {
      let reader = new FileReader()
      let that = this
      this.$f7.modal({
        title: 'Charging File',
        text: '<span class="preloader"></span>'
      })
      reader.onload = (e) => {
        that.attachment = e.target.result
        that.$f7.closeModal()
      }
      reader.readAsBinaryString(file)
    },
    importAttachment () {
      let that = this
      if (that.attachment !== '' && that.attachmentName !== '') {
        let file = btoa(that.attachment)
        this.$engine.pain08.importFile(
          this.attachmentName,
          file
        ).then(resp => {
          // TODO:
          // loopUntilFinished(resp.data.IdFile)
          loadPage(that, {url: '/pain008/traitement/'})
        })
      } else {
        that.$f7.alert('', 'Data missing')
      }
      var file = this.$refs.fileInput.files[0]
      if (file.type !== "text/xml") {
        that.$f7.alert('Veuillez sélectionner un fichier XML', 'Erreur du type du fichier')
        return
      }
    },
    /*
    loopUntilFinished (IdFile) {
      let that = this
      this.activateSpinner = false
      filterConditions = {
        IdFile: IdFile
      }
      this.$engine.pain08.update(
        1,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data.Results && resp.data.Results[0] && resp.data.Results[0].Status === '5') {
          result = resp.data.Results[0]
          let DetailsOK = []
          let DetailsKO = []
          if (result.DetailsOK)
          {
            for (var j = 0; j < result.DetailsOK.length; j++)
            {
              let dateimportOK = result.DetailsOK[j].dateimport
              if (dateimportOK) {
                dateimportOK = this.convertTime(dateimportOK)
              }
              let detailsOK = {
                namefile: result.DetailsOK[j].namefile,
                dateimport: dateimportOK,
                nblignes: result.DetailsOK[j].nblignes
              }
              DetailsOK.push(detailsOK)
            }

            for (var z = 0; z < result.DetailsKO.length; z++)
            {
              let dateimportKO = result.DetailsKO[z].dateimport
              if (dateimportKO) {
                dateimportKO = this.convertTime(dateimportKO)
              }
              let detailsKO = {
                namefile: result.DetailsKO[z].namefile,
                dateimport: dateimportKO,
                nblignes: result.DetailsKO[z].nblignes
              }
              DetailsKO.push(detailsKO)
            }
          }
          that.DetailsOK = DetailsOK
          that.DetailsKO = DetailsKO
          that.activateSpinner = false
          that.showPopupDetails = true
        } else {
          // wait 1 second
          loopUntilFinished(IdFile)
        }
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    }
    */
    onFileChange (e) {
      /* eslint-disable no-undef */
      let that = this
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 1000000) {
        that.createImage(files[0])
        that.attachmentName = files[0].name
        that.mimeType = files[0].type
      } else {
        that.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 1MB', 'Maximum file size exceeded')
      }
      var file = e.target.files[0]
      if (!file || !file.type || file.type !== 'text/xml') {
        that.$f7.alert('Veuillez sélectionner un fichier XML', 'Erreur du type du fichier')
        return
      }
    },
    // showPopup () {
    //   let that = this
    //   if (that.attachment !== '' && that.attachmentName !== '') {
    //     this.importAttachment()
    //     this.$bus.$emit('popup-import-file', {
    //     })
    //   } else {
    //     that.$f7.alert('', 'Data missing')
    //   }
    // }
  }
}

</script>
